module.exports = __webpack_public_path__ + "static/img/depositGiftImg.5edff7d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/depositGiftImg.webp
// module id = 2dcb
// module chunks = 0